module.exports = __webpack_public_path__ + "media/images/icons/icon-file-download-5f10618743f59de5447c28f561e9466a.svg";